<router-outlet (activate)="onActivate($event)">
  <div *ngIf="loading" class="root-loading">
    <suvo-core-loading-spinner message="Loading..."></suvo-core-loading-spinner>
  </div>
</router-outlet>
<app-is-navigating></app-is-navigating>
